import React from 'react';
import { Editor } from 'slate';
import { Plugin, CustomEditor, CustomText } from '../types';

const ColorPlugin: Plugin = {
  name: 'color',
  
  commands: {
    setTextColor: (editor: CustomEditor, color: string) => {
      Editor.addMark(editor, 'color', color);
    },
    
    setBackgroundColor: (editor: CustomEditor, color: string) => {
      Editor.addMark(editor, 'backgroundColor', color);
    }
  }
};

export default ColorPlugin; 